if (!rtAPI) var rtAPI = {};
if (!rtAPI.security) rtAPI.security = {};

//#region Panel Updates

rtAPI.security.updatePanels = async function (result) {
    //debugger
    //Setup visibility of elements
    var btnTFASelectCancel = 'none';
    var btnTFAHardwareKeyRegister = 'inherit';
    var btnTFAHardwareKeyRetry = 'inherit';
    if (!rtAPI.security.enableAccountActivation || !result.emailAccountActivationEnabled) rtAPI.displayElement(this.btn.resendAuthEmail, 'none');
    if (!rtAPI.security.enableGetUsername || !result.getUsernameEnabled) rtAPI.displayElement(this.btn.lostUsername, 'none');
    if (!rtAPI.security.enableGetPassword) rtAPI.displayElement(this.btn.lostPassword, 'none');
    if (!rtAPI.security.enableTFAManagement) {
        document.querySelectorAll(`label[for='${this.fd.manageTFA.id}']`).forEach((item) => { rtAPI.displayElement(item, 'none') });
        //rtAPI.displayElement(document.querySelector(`label[for='${this.fd.manageTFA.id}']`), 'none');
        //rtAPI.displayElement(this.fd.manageTFA, 'none');
        rtAPI.displayElement(rtAPI.security.btn.tFAManageBack, 'none');
    }

    //Setup pnls
    var pnlLogin = 'none';
    var pnlLogout = 'none';
    var pnlTFASelect = 'none';
    var pnlTFACode = 'none';
    var pnlTFAMemorableData = 'none';
    var pnlTFAHardwareKey = 'none';

    switch (result.loginPanelMode) {
        case "Logout":
            pnlLogout = 'inherit';
            rtAPI.security.tFASelectModeTriggered = false;
            rtAPI.security.clearFields();
            rtAPI.security.tFAData = result.tFAData;
            rtAPI.security.init2FAManagePanel();
            break;

        case "Login":
            pnlLogin = 'inherit';
            rtAPI.security.tFASelectModeTriggered = false;
            break;

        case "2FASelect":
            btnTFASelectCancel = 'inherit';
            rtAPI.security.init2FASelectPanel(result);
            break;

        case "2FACode":
            pnlTFACode = 'inherit';
            rtAPI.security.fd.authenticationCode.value = result.code;
            break;

        case "2FAMemorableData":
            pnlTFAMemorableData = 'inherit';
            rtAPI.security.init2FAMemorableDataPanel(result);
            break;

        case "2FAHardwareKey":
            pnlTFAHardwareKey = 'inherit';
            if (rtAPI.security.fireTFAHardwareKeyLoginWhenSelected) {
                rtAPI.security.fireTFAHardwareKeyLoginWhenSelected = false;
                btnTFAHardwareKeyRegister = 'none';
                btnTFAHardwareKeyRetry = 'none';
                success = await rtAPI.security.hardwareKey.triggerLogin()
                if (success) return;
            }
            rtAPI.displayElement(this.btn.tFAHardwareKeyRegister, btnTFAHardwareKeyRegister);
            rtAPI.displayElement(this.btn.tFAHardwareKeyRetry, btnTFAHardwareKeyRetry);
            break;
    }

    rtAPI.displayElement(this.btn.tFASelectCancel, btnTFASelectCancel);
    if (rtAPI.security.tFASelectModeTriggered) pnlTFASelect = 'inherit';
    else rtAPI.security.renderedTFAOptions = "";

    //Do callback
    if (typeof this.panelUpdateCallback === 'function') {
        result.abortPanelUpdate = false;
        this.panelUpdateCallback(result);
        if (result.abortPanelUpdate) return;
    }

    //Update displayed panels
    rtAPI.displayElement(this.pnl.login, pnlLogin);
    rtAPI.displayElement(this.pnl.logout, pnlLogout);
    rtAPI.displayElement(this.pnl.tFASelect, pnlTFASelect);
    rtAPI.displayElement(this.pnl.tFACode, pnlTFACode);
    rtAPI.displayElement(this.pnl.tFAMemorableData, pnlTFAMemorableData);
    rtAPI.displayElement(this.pnl.tFAHardwareKey, pnlTFAHardwareKey);
    if (result.isLoggedIn && rtAPI.security.enableTFAManagement && rtAPI.security.showTFAManagement) rtAPI.security.openSecurityDialog();
    if (result.mustChangePassword) rtAPI.security.handle.showMustChangePassword();
    if (result.recoverPassword) rtAPI.security.handle.initRecoverPassword();

    var newVirtualPage = (rtAPI.security.lastPanelMode != result.loginPanelMode && rtAPI.security.lastPanelMode != "" && rtAPI.security.initialising == false && rtAPI.security.initSecurityDialogRun == true)
    rtAPI.security.lastPanelMode = result.loginPanelMode;

    if (newVirtualPage) {
        if (result.loginPanelMode == 'Logout') {
            var returnURL = rtAPI.query.params.get('fdReturnURL');
            var hasReturnURL = !(rtAPI.isEmptyString(returnURL));
            if (rtAPI.security.samePageLogin && !hasReturnURL) {
                rtAPI.updatePostbackCounter();
            }
            //debugger;
            if (!rtAPI.security.enableTFAManagement && hasReturnURL) document.location = rtAPI.query.params.get('fdReturnURL');//Backup to trigger redirect to return URL if samepage login fails to work via json header
        }
        else {
            rtAPI.updatePostbackCounter();
        }
        //rtAPI.security.pnl.dialog.addDiv({ 'sid': 'api-security-login-complete', className: 'aspNetHidden' });
    }
}

//#endregion

//#region 2FA Select Panel

rtAPI.security.init2FASelectPanel = function (result) {
    rtAPI.security.tFASelectModeTriggered = true;
    if (JSON.stringify(result.tFAData.options) == JSON.stringify(rtAPI.security.renderedTFAOptions)) return;
    rtAPI.security.renderedTFAOptions = result.tFAData.options;
    rtAPI.security.pnl.tFASelectOptions.innerHTML = '';
    for (const option of result.tFAData.options) {
        if (!option.available) continue;
        if (!option.enabled) continue;
        if (!option.interactive) continue;

        rtAPI.security.pnl.tFASelectOptions.extendDOM();
        var spanElement = rtAPI.security.pnl.tFASelectOptions.addSpan();
        spanElement.addRadioButtonAndLabel(`tFAOption${option.method}`, 'tFAOptions', `${option.titleUse}`, `${option.method}`, `pnl-two-factor-authentication-select-options-${option.method.toLowerCase()}`, this.handle.sendSelect2FAMethod)
    }
}

//#endregion

//#region 2FA Memorable Data Panel

rtAPI.security.init2FAMemorableDataPanel = function (result) {
    rtAPI.security.pnl.tFAMemorableDataFields.innerHTML = '';
    if (result.memorableDataHintVisible) {
        rtAPI.security.pnl.tFAMemorableDataFields.extendDOM();
        var hintElement = rtAPI.security.pnl.tFAMemorableDataFields.addSpan({ id: 'pnl2FAMemorableDataHint' });
        hintElement.addSpan({ className: 'memorable-data-hint-title', text: result.memorableDataHintTitle });
        hintElement.addSpan({ className: 'memorable-data-hint-text', text: result.memorableDataHintText });
    }
    var fields = [result.memorableDataLabel1, result.memorableDataLabel2, result.memorableDataLabel3];
    var counter = 1
    fields.forEach(function (item) {
        var fieldsElement = rtAPI.security.pnl.tFAMemorableDataFields.addSpan({ id: `pnlmemorableData${counter}`, className: 'pnlmemorableData' });
        var inputElement = fieldsElement.addPasswordAndLabel(`memorableData${counter}`, 1, `${item}`, `pnl-two-factor-authentication-memorable-data-${counter}`, 'requiredGroupMemorableData', eval(`result.memorableDataErrorMessage${counter}`), null, null, null).input;
        if (counter > 1) document.getElementById('memorableData' + (counter - 1)).addEventListener('input', function () { rtAPI.security.init2FAMemorableDataPanelAutoTab(this, inputElement) });
        counter++;
    })
    document.getElementById('memorableData' + (counter - 1)).addButtonToClick(this.btn.tFAMemorableDataSubmit);
}

rtAPI.security.init2FAMemorableDataPanelAutoTab = function (current, to) {
    if (current.getAttribute && current.value.length == current.getAttribute("maxlength")) to.focus();
}

//#endregion

//#region 2FA Manage Panel

rtAPI.security.init2FAManagePanel = function () {

    if (!rtAPI.security.showTFAManagement) return;

    //debugger;
    if (rtAPI.security.dialogModeIs('2FAManagePanel')) return;
    rtAPI.security.clearSecurityDialog();
    rtAPI.security.resizeSecurityDialog(600, 460);

    for (const option of rtAPI.security.tFAData.options) {
        if (!option.available) continue;

        var rowElement = rtAPI.security.pnl.dialogFields.addDiv({ 'className': 'tFAManageOptionRow' });
        var spanElementData = { bdClassName: 'tFAManageOptionCheckbox', label1Id: `tFAManageOptionImage${option.method}`, label1ClassName: 'tFAManageOptionImage', label2Id: `tFAManageOptionText${option.method}`, label2ClassName: 'tFAManageOptionText' };
        rowElement.addToggleSwitch(`tFAManageOption${option.method}`, `${option.titleEnable}`, `${option.method}`, option.enabled, `pnl-two-factor-authentication-manage-options-${option.method.toLowerCase()}`, rtAPI.security.handle.tFAManageOptionToggle, spanElementData);
        if (option.buttonAction != '') {
            var spanButtonElement = rowElement.addSpan({ className: 'button-span' });
            spanButtonElement.addButton(`tFAManageOptionButton${option.method}`, option.buttonText, eval(`rtAPI.security.handle.tFAManageOption${option.buttonAction}`), (!option.enabled && !option.alwaysShowButton), 'button button-TFA button-manage');
        }
    }

    for (const option of rtAPI.security.tFAData.options) {
        if (!option.available) continue;
        for (const field of option.fields) {
            rtAPI.security.create2FAManageUpdatePanelField(field);
        }
    }

    this.btn.tFAManageHardwareKeyAdd = rtAPI.security.pnl.dialogButtons.addButton('tFAManageHardwareKeyAdd', rtAPI.security.tFAData.text.hardwareKeyAdd, this.handle.tFAManageHardwareKeyAdd, true, 'button');
    this.btn.tFAManageUpdate = rtAPI.security.pnl.dialogButtons.addButton('tFAManageUpdate', rtAPI.security.tFAData.text.btnUpdate, this.handle.tFAManageUpdate, true, 'button');

    rtAPI.security.addDefaultSecurityDialogButtons(false, true);
    rtAPI.security.fd.tFAUpdatePassword = rtAPI.security.create2FAManageUpdatePanelField(rtAPI.security.tFAData.password);
    rtAPI.security.update2FAManagePanel();
}

rtAPI.security.create2FAManageUpdatePanelField = function (field) {
    var spanElement = rtAPI.security.pnl.dialogFields.addSpan({ 'id': field.pnlId, className: 'tfa-manage-field' });
    spanElement.addLabel(field.id, field.titleField);
    var inputElement = spanElement.addInput(field.type.toLowerCase(), field.id, null, `tfa-manage-field-${field.id}`, null, null, rtAPI.security.handle.tFAManageFieldInput, null, false, field.validators, field.initialValue);
    inputElement.addDataChanged(field);
    return inputElement;
}

rtAPI.security.update2FAManagePanel = function () {
    rtAPI.security.btn.tFAManageUpdate.style.display = rtAPI.security.tFAManageOptionsChanged() ? '' : 'none';
    rtAPI.security.update2FAManageField(rtAPI.security.tFAData.password, rtAPI.security.tFAManageOptionsChanged());

    for (const option of rtAPI.security.tFAData.options) {
        if (!option.available) continue;
        var targetSwitch = document.getElementById(`tFAManageOption${option.method}`);
        targetSwitch.checked = option.newState;
        for (const field of option.fields) {
            rtAPI.security.update2FAManageField(field, option.newState);
        }
        if (option.buttonAction != '') {
            let buttonManageVisible = ((option.enabled == option.newState && option.newState) || option.alwaysShowButton);
            document.getElementById(`tFAManageOptionButton${option.method}`).style.display = buttonManageVisible ? 'inline-block' : 'none';
        }
    }
}

rtAPI.security.update2FAManageField = function (field, enabled) {
    document.getElementById(field.pnlId).style.display = enabled ? '' : 'none';
    var targetInput = document.getElementById(field.id);
    if (field.value != targetInput.value) targetInput.value = field.value; //Used to resync data after api call

    for (const validator of field.validators) {
        switch (validator.validationType) {
            case "Required":
                if (enabled) {
                    if (field.initialValue != '') targetInput.setAttribute('required', '');
                }
                else targetInput.removeAttribute('required');
                return;

            default:
                continue;
        }
    }

}

rtAPI.security.tFAManageOptionsChanged = function () {
    if (!rtAPI.security.showTFAManagement) return false;
    if (rtAPI.security.pnl.dialogFields.innerHTML == '') return false;

    for (const option of rtAPI.security.tFAData.options) {
        if (!option.available) continue;
        if (option.enabled == option.newState && !rtAPI.security.tFAManageOptionFieldsChanged(option)) continue;
        return true;
    }
    return false;
}

rtAPI.security.tFAManageOptionFieldsChanged = function (option) {
    if (!rtAPI.security.showTFAManagement) return false;
    if (rtAPI.security.pnl.dialogFields.innerHTML == '') return false;

    for (const field of option.fields) {
        if (field.value == field.initialValue) continue;
        return true;
    }
    return false;
}

rtAPI.security.tFAManageOptionsAreValid = function () {
    var isValid = true;
    if (!rtAPI.security.tFAManageFieldIsValid(rtAPI.security.tFAData.password)) isValid = false;
    for (const option of rtAPI.security.tFAData.options) {
        if (!option.available) continue;
        if (!option.newState) continue;
        for (const field of option.fields) {
            if (!rtAPI.security.tFAManageFieldIsValid(field)) isValid = false;
        }
    }
    return isValid;
}

rtAPI.security.tFAManageFieldIsValid = function (field) {
    var targetInput = document.getElementById(field.id);
    for (const validator of field.validators) {
        switch (validator.validationType) {
            case "Required":
                targetInput.setAttribute('required', '');
                if (!targetInput.validity.valueMissing) continue;
                targetInput.reportValidity();
                rtAPI.messages.addCritical(validator.errorMessage, true);
                return false;

            case "MinLength":
                if (!targetInput.validity.tooShort) continue;
                targetInput.reportValidity();
                rtAPI.messages.addCritical(validator.errorMessage, true);
                return false;

            case "Pattern":
                if (!targetInput.validity.patternMismatch) continue;
                targetInput.reportValidity();
                rtAPI.messages.addCritical(validator.errorMessage, true);
                return false;
        }
    }
    return true;
}

//rtAPI.security.requiredIsValid = function (targetInput) {
//    //debugger;
//    targetInput.setAttribute('required', '');
//    if (!targetInput.validity.valueMissing) return true;
//    targetInput.reportValidity();
//    rtAPI.messages.addCritical(targetInput.requiredErrorMessage, true);
//    return false;
//}

//#endregion

//#region 2FA Manage HardwareKey Panel (Needs to be updated using DOMExtensions)

rtAPI.security.init2FAManageHardwareKeyPanel = function () {
    if (!rtAPI.security.showTFAManagement) return;

    rtAPI.security.pnl.dialogFields.innerHTML = '';
    const mHK = rtAPI.security.tFAData.manageTFAHardwareKey;
    var rowH3Element = document.createElement('h3');
    rowH3Element.className = 'tFAManageHardwareKeyPanelTitle';
    rowH3Element.innerText = mHK.title;
    rtAPI.security.pnl.dialogFields.appendChild(rowH3Element);

    var tableElement = document.createElement('div');
    tableElement.className = 'tFAManageOptionTable';
    rtAPI.security.pnl.dialogFields.appendChild(tableElement);

    var rowHElement = document.createElement('div');
    rowHElement.className = 'tFAManageOptionRow tFAHeader';
    tableElement.appendChild(rowHElement);

    var spanHUserIdentElement = document.createElement('span');
    spanHUserIdentElement.className = 'tFAManageOptionCell tFAManageOptionHardwareKeyUserIdent';
    spanHUserIdentElement.innerText = rtAPI.security.tFAData.text.deviceTableHeadings[0];
    rowHElement.appendChild(spanHUserIdentElement);

    var spanHButtonElement = document.createElement('span');
    spanHButtonElement.className = 'tFAManageOptionCell tFAManageOptionHardwareKeyStatusText';
    spanHButtonElement.innerText = rtAPI.security.tFAData.text.deviceTableHeadings[1];
    rowHElement.appendChild(spanHButtonElement);

    for (const hardwareKey of mHK.hardwareKeys) {
        var rowElement = document.createElement('div');
        rowElement.className = 'tFAManageOptionRow';
        tableElement.appendChild(rowElement);

        var spanUserIdentElement = document.createElement('span');
        spanUserIdentElement.className = 'tFAManageOptionCell tFAManageOptionHardwareKeyUserIdent';
        spanUserIdentElement.innerText = hardwareKey.UserIdent;
        rowElement.appendChild(spanUserIdentElement);

        var spanButtonElement = document.createElement('span');
        spanButtonElement.className = 'tFAManageOptionCell button-span';
        rowElement.appendChild(spanButtonElement);

        if (hardwareKey.Authorised) {
            var spanAuthorisedElement = document.createElement('span');
            spanAuthorisedElement.className = 'tFAManageOptionHardwareKeyStatus';
            spanAuthorisedElement.innerText = rtAPI.security.tFAData.text.hardwareKeyAuthorised;
            spanButtonElement.appendChild(spanAuthorisedElement);
        }
        else {
            var buttonAuthoriseElement = document.createElement('button');
            spanButtonElement.appendChild(buttonAuthoriseElement);
            buttonAuthoriseElement.id = `tFAManageOptionHardwareKeyAuthorise${hardwareKey.Id}`;
            buttonAuthoriseElement.idDB = hardwareKey.Id;
            buttonAuthoriseElement.userIdent = hardwareKey.UserIdent;
            buttonAuthoriseElement.className = 'button button-TFA button-authorise';
            buttonAuthoriseElement.innerText = rtAPI.security.tFAData.text.hardwareKeyAuthorise;
            buttonAuthoriseElement.addEventListener('click', rtAPI.security.handle.tFAManageAuthorise);
        }

        if (mHK.allowRemove) {
            var buttonRemoveElement = document.createElement('button');
            spanButtonElement.appendChild(buttonRemoveElement);
            buttonRemoveElement.id = `tFAManageOptionHardwareKeyRemove${hardwareKey.Id}`;
            buttonRemoveElement.idDB = hardwareKey.Id;
            buttonRemoveElement.userIdent = hardwareKey.UserIdent;
            buttonRemoveElement.innerText = rtAPI.security.tFAData.text.hardwareKeyRemove;
            buttonRemoveElement.className = 'button button-TFA button-remove';
            buttonRemoveElement.addEventListener('click', rtAPI.security.handle.tFAManageRemove);
        }

    }
    rtAPI.displayElement(this.btn.tFAManageHardwareKeyAdd, 'inline-block');
    rtAPI.displayElement(this.btn.tFAManageBack, 'inline-block');
    rtAPI.displayElement(this.btn.tFAManageClose, 'none');
}

rtAPI.security.updateManageHardwareKeyPanels = function (result) {
    rtAPI.security.tFAData = result.tFAData;
    rtAPI.security.init2FAManageHardwareKeyPanel();
}

//#endregion

//#region 2FA Manage AuthorisedDevice Panel

rtAPI.security.init2FAManageAuthorisedDevicePanel = function () {

    //debugger;
    if (!rtAPI.security.showTFAManagement) return;

    // Needs to always redraw
    rtAPI.security.dialogMode = 'AuthorisedDevicePanel';

    rtAPI.security.clearSecurityDialog();
    rtAPI.security.resizeSecurityDialog(750, 460);
    rtAPI.security.addDefaultSecurityDialogButtons(true, false);

    const mAD = rtAPI.security.tFAData.manageTFAAuthorisedDevice;

    rtAPI.security.pnl.dialogTitle.innerText = mAD.title;
    if (mAD.authorisedDevices.length == 0) {
        rtAPI.security.pnl.dialogFields.addDiv({ className: 'tFAManageAuthOptionEmptyTable', text: rtAPI.security.tFAData.text.noDevices });
        return;
    }

    var tableElement = rtAPI.security.pnl.dialogFields.addDiv({ className: 'tFAManageAuthOptionTable' });
    var rowHElement = tableElement.addDiv({ className: 'tFAManageAuthOptionRow tFAHeader' });
    rowHElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionAuthorisedDeviceBrowser', text: rtAPI.security.tFAData.text.deviceTableHeadings[0] });
    rowHElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionAuthorisedDeviceDescription', text: rtAPI.security.tFAData.text.deviceTableHeadings[1] });
    rowHElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionAuthorisedDeviceIPAddress', text: rtAPI.security.tFAData.text.deviceTableHeadings[2] });
    rowHElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionAuthorisedDeviceLoginCounter', text: rtAPI.security.tFAData.text.deviceTableHeadings[3] });
    if (mAD.enabled) {
        rowHElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionStatusText', text: rtAPI.security.tFAData.text.deviceTableHeadings[4] });
        rowHElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionRemove', text: '&nbsp;' });
    }

    for (const authorisedDevice of mAD.authorisedDevices) {
        var rowElement = tableElement.addDiv({ className: 'tFAManageAuthOptionRow' });
        rowElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionAuthorisedDeviceBrowser', text: authorisedDevice.Browser });
        rowElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionAuthorisedDeviceDescription', text: authorisedDevice.Description });
        rowElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionAuthorisedDeviceIPAddress', text: authorisedDevice.IPAddress });
        rowElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionAuthorisedDeviceLoginCounter', text: authorisedDevice.LoginCounter });
        var spanStatusElement = rowElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionAuthorisedDeviceStatus' });
        if (mAD.enabled) {
            if (authorisedDevice.Activated) {
                spanStatusElement.addSpan({ className: 'tFAManageOptionAuthorisedDeviceStatus', text: rtAPI.security.tFAData.text.deviceAuthorised });
            }
            else {
                var buttonAuthoriseElement = spanStatusElement.addButton(`tFAManageOptionAuthorisedDeviceAuthorise${authorisedDevice.Id}`, rtAPI.security.tFAData.text.deviceAuthorise, rtAPI.security.handle.tFAManageAuthorisedDeviceAuthorise, false, 'button button-TFA button-authorise');
                buttonAuthoriseElement.idDB = authorisedDevice.Id;
                buttonAuthoriseElement.name = authorisedDevice.Name;
            }
        }

        var spanRemoveButtonElement = rowElement.addSpan({ className: 'tFAManageAuthOptionCell tFAManageOptionAuthorisedRemove' });

        var buttonRemoveElement = spanRemoveButtonElement.addButton(`tFAManageOptionAuthorisedDeviceRemove${authorisedDevice.Id}`, rtAPI.security.tFAData.text.deviceRemove, rtAPI.security.handle.tFAManageAuthorisedDeviceRemove, false, 'button button-TFA button-remove');
        buttonRemoveElement.idDB = authorisedDevice.Id;
        buttonRemoveElement.name = authorisedDevice.Name;
    }
}

rtAPI.security.updateManageAuthorisedDevicePanels = function (result) {
    rtAPI.security.tFAData = result.tFAData;
    rtAPI.security.init2FAManageAuthorisedDevicePanel();
}

//#endregion

//#region Update Password

rtAPI.security.initUpdatePasswordPanel = async function () {
    //debugger;
    rtAPI.messages.target = 'pnlSecurityDialog_Messages';
    if (rtAPI.security.dialogModeIs('UpdatePasswordPanel')) return;
    rtAPI.security.changePasswordMode = 'user';
    rtAPI.security.initCommonPasswordPanel(rtAPI.security.tFAData.text.changePassword, true);
}

rtAPI.security.initMustChangePassword = async function () {

    //debugger;
    rtAPI.messages.target = 'pnlSecurityDialog_Messages';
    if (rtAPI.security.dialogModeIs('MustChangePasswordPanel')) return;
    rtAPI.security.changePasswordMode = 'force';
    rtAPI.security.initCommonPasswordPanel(rtAPI.security.tFAData.text.mustChangePassword, false);
}

rtAPI.security.initRecoverPassword = async function () {

    //debugger;
    rtAPI.messages.target = 'pnlSecurityDialog_Messages';
    if (rtAPI.security.dialogModeIs('RecoverPasswordPanel')) return;
    rtAPI.security.changePasswordMode = 'recover';
    rtAPI.security.initCommonPasswordPanel(rtAPI.security.tFAData.text.recoverPassword, false);

    ////rtAPI.query.params.get('');


}

rtAPI.security.initCommonPasswordPanel = async function (title, showOldPassword, handler) {

    //debugger;

    rtAPI.security.clearSecurityDialog();
    rtAPI.security.resizeSecurityDialog();
    rtAPI.security.pnl.dialogTitle.innerText = title;

    //(id, maxChars, title, sidKey, requiredGroup, requiredMessage, clickEventHandler, className, spanData)'
    if (showOldPassword) rtAPI.security.fd.oldPassword = rtAPI.security.pnl.dialogFields.addPasswordAndLabel('fdOldPassword', null, rtAPI.security.tFAData.text.oldPassword, 'fd-old-password', 'requiredGroupUpdatePassword', rtAPI.security.tFAData.errorMessage.oldPassword, null, null, { className: 'tfa-manage-field' }).input;
    rtAPI.security.fd.newPassword = rtAPI.security.pnl.dialogFields.addPasswordAndLabel('fdNewPassword', null, rtAPI.security.tFAData.text.newPassword, 'fd-new-password', 'requiredGroupUpdatePassword', rtAPI.security.tFAData.errorMessage.newPassword, null, null, { className: 'tfa-manage-field' }).input;
    rtAPI.security.fd.retypeNewPassword = rtAPI.security.pnl.dialogFields.addPasswordAndLabel('fdRetypeNewPassword', null, rtAPI.security.tFAData.text.retypeNewPassword, 'fd-retype-password', '', rtAPI.security.tFAData.errorMessage.retypeNewPassword, null, null, { className: 'tfa-manage-field' }).input;
    rtAPI.security.pnl.dialogFields.addDiv({ id: 'pass_help_' + rtAPI.security.fd.newPassword.id, className: 'pass_help', hidden: true });
    rtAPI.security.pnl.dialogFields.addDiv({ id: 'pass_score_' + rtAPI.security.fd.newPassword.id, className: 'pass_score', hidden: true });

    rtAPI.security.call.getPasswordScoreInfo()
        .then(result => {
            var id = rtAPI.security.fd.newPassword.id;
            globalThis.pass = {};
            eval(`globalThis.pass.displayType_${id} = result.data.passDisplayType;`);
            eval(`globalThis.pass.useHelp_${id} = result.data.passUseHelp;`);
            eval(`globalThis.pass.showOk_${id} = result.data.passShowOk;`);
            eval(`globalThis.pass.standards_${id} = result.data.passStandards;`);
            eval(`globalThis.pass.complexities_${id} = result.data.passComplexities;`);
            eval(`globalThis.pass.complexityThresholds_${id} = result.data.passComplexityThresholds;`);
            eval(`globalThis.pass.mins_${id} = result.data.passMins;`);
        })

    rtAPI.security.fd.newPassword.addEventListener('input', function () { rtAPI.security.handle.inputPasswordField(this) });
    rtAPI.security.btn.updatePassword = rtAPI.security.pnl.dialogButtons.addButton('btnUpdate', rtAPI.security.tFAData.text.btnUpdate, rtAPI.security.handle.updatePassword, false, 'button', 'btn-Update-password')
    rtAPI.security.addDefaultSecurityDialogButtons(false, true);
}


//#endregion

